import React from 'react';
import VideoJS from 'video.js';
import Player from '../../../../components/Player';
import 'video.js/dist/video-js.css';
import { setPlayer } from '../../../../actions/createAssets';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import controlsVjs from '../../../../components/Player/controlsVjs';
import { setVideoSrcFallBack } from '../../../../utils/ipfs';

const videoJSOptions = {
    autoplay: true,
    controls: true,
    loop: false,
    width: 500,
    height: 600,
    controlBar: {
        children: [
            'currentTimeDisplay',
            'timeDivider',
            'progressControl',
            'FullscreenToggle',
        ],
    },
    userActions: {
        doubleClick: false,
    },
};

class Preview extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            activeSrc: 0,
        };
        this.initializePlayer = this.initializePlayer.bind(this);
        this.handleSetAlternateSource = this.handleSetAlternateSource.bind(this);
    }

    initializePlayer (ref) {
        if (this.props.manual) {
            videoJSOptions.autoplay = false;
        }

        this.player = VideoJS(ref, videoJSOptions);
        if (this.player) {
            this.props.setPlayer(this.player);
            this.player.addChild('controlsVjs', {});
            if (this.props.type !== 'hls' || this.props.type !== 'dash') {
                this.handleSetAlternateSource();
            }
            if (this.props.poster) {
                this.player.poster(this.props.poster);
            }
        }
    }

    handleSetAlternateSource () {
        let bufferedPercent = null;
        const array = setVideoSrcFallBack(this.props.url);
        const interval = setInterval(() => {
            if (this.player && this.player.bufferedPercent() && this.player.bufferedPercent() > 0.1) {
                clearInterval(interval);
                return;
            }
            if (this.player && bufferedPercent === this.player.bufferedPercent() && !this.player.paused()) {
                if (array.length > this.state.activeSrc) {
                    const src = array[this.state.activeSrc + 1];
                    if (src) {
                        this.player.src(src);
                        this.setState({
                            activeSrc: this.state.activeSrc + 1,
                        });
                        clearInterval(interval);
                        this.handleSetAlternateSource();
                    } else {
                        clearInterval(interval);
                    }
                }
            }
            bufferedPercent = this.player && this.player.bufferedPercent();
        }, 10000);
    }

    componentWillUnmount () {
        if (this.player) {
            this.player.removeChild('controlsVjs', {});
            this.player.dispose();
            this.setState({
                activeSrc: 0,
            });
        }
    }

    setup () {
        let config;
        if (this.props.type === 'hls') {
            config = {
                sources: [{
                    type: 'application/x-mpegURL',
                    src: this.props.url,
                }],
            };
        } else if (this.props.type === 'dash') {
            config = {
                sources: [{
                    type: 'application/dash+xml',
                    src: this.props.url,
                }],
            };
        } else {
            config = {
                sources: setVideoSrcFallBack(this.props.url),
            };
        }

        return JSON.stringify(config);
    }

    render () {
        return (
            <div className="player">
                <Player
                    initializePlayer={this.initializePlayer}
                    setup={this.setup()}/>
            </div>
        );
    }
}

Preview.propTypes = {
    setPlayer: PropTypes.func.isRequired,
    manual: PropTypes.bool,
    poster: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string,
};

const actionToProps = {
    setPlayer,
};

export default connect(null, actionToProps)(Preview);
